module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_blueGreen.1a50b2b5.svg";